module.exports = __webpack_public_path__ + "img/publish.aab37ba2.png";